import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { svgIconStyles as t } from "../svg-icon/SvgIcon.styles.js";
function c({
  label: C,
  className: l,
  size: o,
  ...i
}) {
  return /* @__PURE__ */ n(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      "data-title": "locationOutline",
      stroke: "none",
      role: "img",
      "aria-hidden": !C,
      focusable: "false",
      className: t({ className: l, size: o }),
      ...i,
      children: [
        C && /* @__PURE__ */ e("title", { children: C }),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.3754 8.89759C15.3754 10.7035 13.8643 12.1676 12.0003 12.1676C10.1363 12.1676 8.6252 10.7035 8.6252 8.89759C8.6252 7.09163 10.1363 5.62761 12.0003 5.62761C13.8643 5.62761 15.3754 7.09163 15.3754 8.89759ZM13.3044 8.89759C13.3044 9.59537 12.7205 10.161 12.0003 10.161C11.2801 10.161 10.6962 9.59537 10.6962 8.89759C10.6962 8.1998 11.2801 7.63413 12.0003 7.63413C12.7205 7.63413 13.3044 8.1998 13.3044 8.89759Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 2C7.58172 2 4 5.47014 4 9.75078C4 10.8865 4.41304 12.2049 4.97459 13.4751C5.5461 14.7679 6.31556 16.1076 7.12222 17.316C7.92805 18.5232 8.78895 19.6263 9.55506 20.4398C9.9359 20.8442 10.3142 21.1995 10.6676 21.4623C10.8442 21.5935 11.0353 21.7174 11.2346 21.8121C11.4223 21.9013 11.6899 22 12 22C12.3101 22 12.5777 21.9013 12.7654 21.8121C12.9647 21.7174 13.1558 21.5935 13.3324 21.4623C13.6858 21.1995 14.0641 20.8442 14.4449 20.4398C15.211 19.6263 16.0719 18.5232 16.8778 17.316C17.6844 16.1076 18.4539 14.7679 19.0254 13.4751C19.587 12.2049 20 10.8865 20 9.75078C20 5.47014 16.4183 2 12 2ZM6.07104 9.75078C6.07104 6.57831 8.72552 4.00652 12 4.00652C15.2745 4.00652 17.929 6.57831 17.929 9.75078C17.929 10.4783 17.6468 11.4973 17.1217 12.6851C16.6065 13.8503 15.8978 15.0892 15.1387 16.2264C14.3788 17.3649 13.5862 18.3746 12.915 19.0874C12.5772 19.4462 12.2909 19.7074 12.0715 19.8705C12.0456 19.8897 12.0218 19.9068 12 19.9218C11.9782 19.9068 11.9544 19.8897 11.9285 19.8705C11.7091 19.7074 11.4228 19.4462 11.085 19.0874C10.4138 18.3746 9.62122 17.3649 8.86127 16.2264C8.10215 15.0892 7.39349 13.8503 6.87834 12.6851C6.35322 11.4973 6.07104 10.4783 6.07104 9.75078Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
export {
  c as LocationOutlineIcon,
  c as default
};
